import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  ThfButtonModule,
  ThfDividerModule,
  ThfDynamicModule,
  ThfGridModule,
  ThfPageModule,
  ThfWidgetModule
} from '@totvs/thf-ui';

import { ThfPageDynamicEditComponent } from './thf-page-dynamic-edit.component';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-dynamic-detail.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    ThfButtonModule,
    ThfDividerModule,
    ThfDynamicModule,
    ThfGridModule,
    ThfPageModule,
    ThfWidgetModule
  ],
  declarations: [
    ThfPageDynamicEditComponent
  ],
  exports: [
    ThfPageDynamicEditComponent
  ]
})
export class ThfPageDynamicEditModule { }
